module.exports = __webpack_public_path__ + "static/media/FinalResult.b76898c9.png";